@if (progressor != null) {
  <p-panel class="overlay">
    <ng-template pTemplate="header">
      <div class="progressor-header">
        <span>Fortschritt</span>
        @if (closable) {
          <button pButton type="button" class="p-button-text p-button-rounded" icon="fas fa-times" aria-label="Fortschrittsanzeige schließen" (click)="onClose.emit()"></button>
        }
      </div>
    </ng-template>
    @if (progressor.max > 0) {
      <p-progressBar [value]="_Utils.toNumber(_Utils.restrictDecimalDigits(_Utils.divSafe(progressor.value * 100, progressor.max), 0))"></p-progressBar>
    }
    @else {
      <p-progressBar mode="indeterminate"></p-progressBar>
    }
    @if (showCalculated && progressor.max > 0) {
      <div><b>{{_Utils.restrictDecimalDigits(progressor.value, 0)}} / {{_Utils.restrictDecimalDigits(progressor.max, 0)}}</b></div>
    }
    <div>{{progressor.text}}</div>
  </p-panel>
}
